/**
 * Service for handling address lookup and retrieval using Loqate API
 */

const createAddressService = (baseUrl, findEndpoint, retrieveEndpoint, apiKey) => ({
  async findAddresses(term, container = 'GB') {
    if (!apiKey) {
      throw new Error('Loqate API key is not configured')
    }
    const response = await fetch(
      `${baseUrl}${findEndpoint}?Key=${apiKey}&Text=${encodeURIComponent(term)}&Countries=GB&Limit=10&Container=${container}`
    )
    if (!response.ok) {
      throw new Error(`Address lookup failed: ${response.statusText}`)
    }
    const data = await response.json()
    return data.Items || []
  },

  async retrieveAddressDetails(id) {
    if (!apiKey) {
      throw new Error('Loqate API key is not configured')
    }
    const response = await fetch(
      `${baseUrl}${retrieveEndpoint}?Key=${apiKey}&Id=${id}`
    )
    if (!response.ok) {
      throw new Error(`Address retrieval failed: ${response.statusText}`)
    }
    const data = await response.json()
    return data.Items?.[0]
  }
})

export default createAddressService 